import PropTypes from 'prop-types';
import { constants } from '../../config/constants';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { ProPriceBadge } from '../ProPrice/ProPrice';
import { CesPricesStyles } from './CesPrices.style';

export const CesBadge = ({ campaignName, discountPercent, cesBadgeLabel }) => {
  return (
    <div className="ces-badges-container">
      <div className={`ces-badge ces-badge-${campaignName?.toLowerCase()}`}>{cesBadgeLabel}</div>
      {discountPercent && (
        <div className={`ces-discount-badge ces-discount-badge-${campaignName?.toLowerCase()}`}>
          - {discountPercent}%
        </div>
      )}
      <style jsx>{CesPricesStyles}</style>
    </div>
  );
};

CesBadge.defaultProps = {
  campaignName: '',
  discountPercent: 0,
  cesBadgeLabel: '',
};

CesBadge.propTypes = {
  campaignName: PropTypes.string,
  discountPercent: PropTypes.number,
  cesBadgeLabel: PropTypes.string,
};

const CesPrices = ({ cesPrice, getUnitPrice, getPrice, product, proPrice, regionCode, appCtx }) => {
  const isWholesaleEnabled = appCtx?.siteConfig?.toggles?.isWholesaleEnabled ?? false;

  const { campaignName, badge, metadata, prices } = cesPrice;
  const cesBadgeLabel = constants.CES_BADGE_LABEL[campaignName];

  const normalPrice = product?.prices
    ?.filter((price) => price.type !== constants.PRICE_TYPE.CMR)
    ?.reduce(
      (max, price) => (!max || parseFloat(price?.price?.[0] ?? 0) > parseFloat(max?.price?.[0] ?? 0) ? price : max),
      null
    );

  const renderUnitPrice = (unitPrice, className, symbol, price) => {
    return (
      <div>
        {Object.entries(unitPrice).length ? (
          <p className={`ces-unit-price-${className}`}>{getUnitPrice(unitPrice, symbol)}</p>
        ) : (
          <p className={`ces-unit-price-${className}`}>{`${getPrice(price, symbol)}`}</p>
        )}
        <style jsx>{CesPricesStyles}</style>
      </div>
    );
  };

  const renderNormalPrice = () => (
    <div>
      {renderUnitPrice(normalPrice?.unitPrice ?? {}, 'normal', normalPrice?.symbol ?? '', normalPrice?.price ?? [])}
    </div>
  );

  const renderCesPrice = () => (
    <div>
      {badge && (
        <CesBadge
          campaignName={campaignName}
          discountPercent={metadata?.discountPercent}
          cesBadgeLabel={cesBadgeLabel}
        />
      )}
      {renderUnitPrice(prices?.[0]?.unitPrice ?? {}, 'ces', prices?.[0]?.symbol ?? '', prices?.[0]?.price ?? [])}
    </div>
  );

  return (
    <div className="ces-prices-container">
      {renderCesPrice()}
      {renderNormalPrice()}
      {proPrice && !isWholesaleEnabled && (
        <div style={{ marginTop: '8px' }}>
          <ProPriceBadge proPrice={proPrice} regionCode={regionCode} />
        </div>
      )}
      <style jsx>{CesPricesStyles}</style>
    </div>
  );
};

CesPrices.defaultProps = {
  cesPrice: {},
  getUnitPrice: () => {},
  getPrice: () => {},
  product: {},
  proPrice: null,
  regionCode: 'cl',
  appCtx: {},
};

CesPrices.propTypes = {
  cesPrice: PropTypes.object,
  getUnitPrice: PropTypes.func,
  getPrice: PropTypes.func,
  product: PropTypes.object,
  proPrice: PropTypes.object,
  regionCode: PropTypes.string,
  appCtx: PropTypes.object,
};

export default withApplicationContext(CesPrices);
